import React from 'react';
import { useTranslation } from 'react-i18next';
import { SaveOutlined } from '@ant-design/icons';
import { Col, Form, Input, Modal, Row } from 'antd';
import { VALIDATE_REQUIRED } from '@/config';
import { useAppContext } from '@/contexts/AppContext';
import { apiSdk } from '@/httpClient';

type Props = {
  onClose: () => void;
};

export default function UpdateProfile({ onClose }: Props) {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const { auth, onUpdateContext } = useAppContext();
  const [loading, setLoading] = React.useState<boolean>(false);
  const updateUserProfile = (values: any) => {
    setLoading(true);
    apiSdk.UserService.updateProfile({
      body: values,
    })
      .then(() => {
        onUpdateContext({
          auth: {
            ...auth,
            firstName: values?.firstName,
            lastName: values?.lastName,
            phone: values?.phone,
          },
        });
        onClose();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal
      visible={true}
      maskClosable={false}
      width={400}
      className="nta-custom-form"
      title={t('updateProfile_title')}
      forceRender={true}
      okText={t('save')}
      cancelText={t('cancel')}
      okButtonProps={{ icon: <SaveOutlined />, className: 'save-btn', loading: loading }}
      onCancel={onClose}
      onOk={() => {
        form
          .validateFields()
          .then(values => {
            updateUserProfile(values);
          })
          .catch(info => {});
      }}
    >
      <Form
        form={form}
        size="middle"
        layout="vertical"
        initialValues={{
          firstName: auth?.firstName,
          lastName: auth?.lastName,
          email: auth?.email,
        }}
      >
        <Form.Item name="id" className="hidden">
          <Input type="hidden" />
        </Form.Item>
        <Row gutter={6}>
          <Col md={24}>
            <Form.Item label={t('updateProfile_FirstName')} name="firstName" rules={[{ required: true, message: VALIDATE_REQUIRED }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col md={24}>
            <Form.Item label={t('updateProfile_LastName')} name="lastName" rules={[{ required: true, message: VALIDATE_REQUIRED }]}>
              <Input />
            </Form.Item>
          </Col>
          <Col md={24}>
            <Form.Item label={t('updateProfile_Phone')} name="phone">
              <Input />
            </Form.Item>
          </Col>
          <Col md={24}>
            <Form.Item label={t('updateProfile_Email')} name="email">
              <Input disabled className="input-value-color" />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
